import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <Container className="text-center py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <div className="mb-4">
            <i className="bi bi-emoji-frown display-1 text-muted"></i>
          </div>
          <h1 className="display-4 fw-bold mb-4">Page Not Found</h1>
          <p className="lead text-muted mb-5">
            The page you are looking for might have been removed, had its name changed,
            or is temporarily unavailable.
          </p>
          <div className="d-flex justify-content-center gap-3">
            <Button as={Link} to="/" variant="primary" size="lg">
              Go Home
            </Button>
            <Button as="a" href="mailto:support@paperdate.io" variant="outline-secondary" size="lg">
              Contact Support
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
